module.exports = __webpack_public_path__ + "img/map.c677d923.png";